import { useEffect, useRef } from "react";

export function useDebugRender(name: string, message?: string): void {
  const count = useRef(0);

  count.current += 1;

  console.log(`${name}: render (${count.current}): ${message || ""}`);

  useEffect(() => {
    console.log(`${name}: mounted`);
    return () => console.log(`${name}: unmounted`);
  }, []);
}
